export default __webpack_public_path__ + "static/media/education-img-cover-color.97f69020.png";